import React, { FC } from 'react';
import useFincode, { Props, ReceivedProps } from '../../Fincode/hook';
import FincodeForm from './FincodeForm';
import Validate3DS2 from './Validate3DS2';

const FincodeLayout: FC<Props> = (props) => {
  const { verify3ds2Url, setVerify3ds2Url, attributes } = props;
  return (
    <>
      <FincodeForm {...props} />
      {verify3ds2Url && (
        <Validate3DS2
          url={verify3ds2Url}
          closeIframe={() => {
            setVerify3ds2Url(undefined);
          }}
          attrs={attributes}
        />
      )}
    </>
  );
};

const Fincode: FC<ReceivedProps> = (props) => (
  <FincodeLayout {...useFincode(props)} />
);

export default Fincode;
